import { createContext, useContext } from "react";
import EmployeeStore from "./employeeStore";
import UserManagementStore from "./userManagementStore";
import JobPostStore from "./jobPostStore";
import InterviewStore from "./interviewStore";
import ModalStore from "./modalStore";
import EventRequestStore from "./eventRequestStore";
import AuthStore from "./authStore";
import UpdateEmployeeStore from "./updateEmployeeStore";
import EventsStore from "./eventsStore";
import AttendanceStore from "./attendanceStore";
import ShiftStore from "./shiftsStore";
import TimeStore from "./timeStore";
import PayrollStore from "./payrollStore";
import SalaryStore from "./salaryStore";
import ApplicantTrackingStore from "./applicantTrackingStore";
import NotificationStore from "./notificationStore";
import OfferLetterStore from "./offerLetterStore";

const store = {
  employeeStore: new EmployeeStore(),
  modalStore: new ModalStore(),
  userManagementStore: new UserManagementStore(),
  jobPostStore: new JobPostStore(),
  interviewStore: new InterviewStore(),
  offerLetterStore: new OfferLetterStore(),
  applicantTrackingStore: new ApplicantTrackingStore(),
  notificationStore: new NotificationStore(),
  eventRequestStore: new EventRequestStore(),
  authStore: new AuthStore(),
  updateEmployeeStore: new UpdateEmployeeStore(),
  eventsStore: new EventsStore(),
  attendaceStore: new AttendanceStore(),
  shiftStore: new ShiftStore(),
  timeStore: new TimeStore(),
  payrollStore: new PayrollStore(),
  salaryStore: new SalaryStore(),
};

export default store;

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}